export { default } from "./accordion-item";
